import { useEffect, useState } from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { useClientViewSummaryQuery, useGetAllActiveUsersQuery, useGetProjectDetailsbyIdQuery, useGetProjectLookupsQuery, useRenewTokenMutation } from '../../../services/EndPointsApis'
import OpportunityDetails from '../LeadsTabs/OpportunityDetails/OpportunityDetails'
import Addenda from './Addenda/Addenda'
import ClientVisit from './ClientVisit/ClientVisit'
import ContigenciesTab from './Contigencies/ContigenciesTab'
import Documents from './Documents/Documents'
import FundingTab from './Funding/FundingTab'
import JobScope from './JobScope/JobScope'
import Assignments from './ProjectAssignments/Assignments'
import ProjectNotes from './ProjectNotes/ProjectNotes'
import ProjectTabsPages from './ProjectTabsPages'
import ProjectTasks from './ProjectTasks/ProjectTasks'
import ProjectUserDetail from './ProjectUserDetail'
import SpecificationExceptionTab from './Specification Exception/SpecificationExceptionTab'
import { useDispatch } from 'react-redux'
import { setProjectData } from '../../../Features/commonSlice'
import SalesInfoTab from './Sale Info/SaleInfoTab'
import Financial from './Financial Tab/Financial'
import { setUser } from '../../../Features/authslice'
import UserInfoCard from '../Projects/User Info Card/UserInfoCard'
import PrintOutTab from './PrintOut Tab/PrintOutTab'
import PermitZoningTab from './Permit & Zoning/Permit&ZoningTab'
import PropertyResource from './Property Resource/PropertyResource'
import DocumentPermissions from './Documents/DocumentsPermissions'
import { usePermission } from '../../../core/hooks/PermissionHook'
import { constantsPermission } from '../../../Config/Constants'
import PCCAddendaPrintOut from './PrintOut Tab/PccAddendaPrinoutsTOpdf/PCCAddendaPrinout'
import Templates from './Templates/Templates'

const ProjectsTabsRoutes = () => {

    //Permission Hook 
    const { view: viewJobInfo, edit: editJobInfo, create: createJobInfo } = usePermission(constantsPermission?.moduleId?.jonInfo);
    const { view: viewAssing, edit: editAssig, create: createAssig } = usePermission(constantsPermission?.moduleId?.assignments);
    const { view: viewOpportunity, edit: editOpportunity, create: createOpportunity } = usePermission(constantsPermission?.moduleId?.opportuityDetails);
    const { view: viewClientVisits, edit: editClientVisits, create: createClientVisits } = usePermission(constantsPermission?.moduleId?.clientVisit);
    const { view: viewNotes, edit: editNotes, create: createNotes } = usePermission(constantsPermission?.moduleId?.notes);
    const { view: viewTasks, edit: editTask, create: createTask } = usePermission(constantsPermission?.moduleId?.task);
    const { view: viewDocuments, edit: editDocuments, create: createDocuments } = usePermission(constantsPermission?.moduleId?.documents);
    const { view: viewJobScope, edit: editJobScope, create: createJobScope } = usePermission(constantsPermission?.moduleId?.jobScope);
    const { view: viewAddenda, edit: editAddenda, create: createAddenda } = usePermission(constantsPermission?.moduleId?.addenda);
    const { view: viewFunding, edit: editFunding, create: createFunding } = usePermission(constantsPermission?.moduleId?.funding);
    const { view: viewContigencies, edit: editContigencies, create: createContigencies } = usePermission(constantsPermission?.moduleId?.contigencies);
    const { view: viewSpecificationException, edit: editSpecificationException, create: createSpecifiationException } = usePermission(constantsPermission?.moduleId?.specificationException);
    const { view: viewDocumentPermission, edit: editDocumentPermission, create: createDocumentPermission } = usePermission(constantsPermission?.moduleId?.documentPermission);
    const { view: viewSaleInfo, edit: editSaleInfo, create: createSaleInfo } = usePermission(constantsPermission?.moduleId?.saleInfo);
    const { view: viewFinancial, edit: editFinancial, create: createFinancial } = usePermission(constantsPermission?.moduleId?.financial);
    const { view: viewPrintOuts, edit: editPrintOuts, create: createPrintOuts } = usePermission(constantsPermission?.moduleId?.printOuts);
    const { view: viewPermitZonning, edit: editPermitZonning, create: createPermitZonning } = usePermission(constantsPermission?.moduleId?.permitZoning);
    const { view: viewPropertyResource, edit: editPropertyResource, create: createPropertyResource } = usePermission(constantsPermission?.moduleId?.propertyResource);
    const { view: viewPCCPDf, edit: editviewPCCPDf, create: createviewPCCPDf } = usePermission(constantsPermission?.moduleId?.propertyResource);
    const { view: viewActionWizards, edit: editActionWizards, create: createActionWizards } = usePermission(constantsPermission?.moduleId?.actionWizards);



    const projectId: string | null = localStorage.getItem('projectId');
    const [toggleInfoCard, setToggleInfoCard] = useState(false);

    const { data: projectByIdData, refetch } = useGetProjectDetailsbyIdQuery({ id: projectId });
    const projectRecordNumber = projectByIdData?.result?.recordNumber
    //project lookups
    const { data: projectLookups, refetch: projectLookupsRefetch } = useGetProjectLookupsQuery('');
    const dispatch = useDispatch();
    const { data: getallActiveUsers, refetch: activeUsersRefetch } = useGetAllActiveUsersQuery('');
    //Client View Summary 
    const { data: clientViewSummary, refetch: refetchClientView } = useClientViewSummaryQuery({ ProjectId: projectId });
    const [refetchApiAfterWizard, setRefetchApiAfterWizard] = useState(false)

    useEffect(() => {
        if (projectId) {
            refetch()
        }
        dispatch(setProjectData(projectByIdData))
    }, [projectId])

    const handlecloseInfoCard = () => {
        setToggleInfoCard(false);
    };
    const handleShowInfoCard = () => {
        setToggleInfoCard(!toggleInfoCard);
    };


    return (
        <>
            <div className=''>
                {/* <button className='btn btn-primary InfoCard-css' onClick={handleShowInfoCard}>
                    Client Details
                </button> */}
            </div>
            <div className="d-flex" >
                <div className="page-wrapper w-100 overflow-auto">
                    <div className="content">
                        {/* <div className="row position-relative">
                        <div className={`${toggleInfoCard ? 'col-md-12' : 'col-md-9'}`}> */}
                        <ProjectTabsPages projectId={`Project ${projectByIdData?.result?.recordNumber}`} getallActiveUsers={getallActiveUsers}
                            refetchProject={refetch} projectByIdData={projectByIdData} projectLookups={projectLookups} projectRecordNumber={projectRecordNumber}
                            refetchClientView={refetchClientView} setToggleInfoCard={setToggleInfoCard} setRefetchApiAfterWizard={setRefetchApiAfterWizard} />
                        <Routes>
                            <Route
                                element={
                                    <>
                                        {/* <ProjectTabsPages projectId={`Project ${projectByIdData?.result?.recordNumber}`} getallActiveUsers={getallActiveUsers}
                                            refetchProject={refetch} projectByIdData={projectByIdData} projectLookups={projectLookups} projectRecordNumber={projectRecordNumber}
                                            refetchClientView={refetchClientView} setToggleInfoCard={setToggleInfoCard} /> */}
                                        <Outlet />
                                    </>
                                }
                            >
                                {/* <Route path={`/details/:projectId`} element={<ProjectUserDetail projectByIdData={projectByIdData} />} /> */}
                                {viewAssing &&
                                    <Route path={`/assignments/:projectId`} element={<Assignments projectLookups={projectLookups} projectId={projectId} projectRecordNumber={projectRecordNumber} refetch={refetch} refetchClientView={refetchClientView} projectByIdData={projectByIdData} />} />
                                }
                                {viewTasks &&
                                    <Route path={`/task/:projectId`} element={<ProjectTasks projectLookups={projectLookups} projectId={projectId} />} />
                                }
                                {viewNotes &&
                                    <Route path={`/notes/:projectId`} element={<ProjectNotes projectId={projectId} projectLookups={projectLookups} />} />
                                }
                                {/* <Route path={`/appointment/:projectId`} element={<AppointmentTab />} /> */}
                                {/* <Route path={`/meetings/:projectId`} element={<Meetings />} /> */}
                                {viewClientVisits &&
                                    <Route path={`/client/:projectId`} element={<ClientVisit projectLookups={projectLookups} projectId={projectId} />} />
                                }
                                {viewJobInfo &&
                                    <Route path={`/details/:projectId`} element={<ProjectUserDetail projectByIdData={projectByIdData} projectId={projectId} />} />
                                }
                                {viewJobScope &&
                                    <Route path={`/job-scope/:projectId`} element={<JobScope projectId={projectId} />} />
                                }
                                {viewDocuments &&
                                    <Route path={`/documents/:projectId`} element={<Documents projectId={projectId} projectLookups={projectLookups} />} />
                                }
                                {viewDocumentPermission &&
                                    <Route path={`/documentPermission/:projectId`} element={<DocumentPermissions projectId={projectId} getallActiveUsers={getallActiveUsers} projectLookups={projectLookups} />} />
                                }
                                {/* <Route path={`/contact/:projectId`} element={<ProjectContacts />} /> */}
                                {viewOpportunity &&
                                    <Route path={`/opportunities/:projectId`} element={<OpportunityDetails projectId={projectId} projectLookups={projectLookups} refetchClientView={refetchClientView} />} />
                                }
                                {viewAddenda &&
                                    <Route path={`/addenda/:projectId`} element={<Addenda projectId={projectId} projectByIdData={projectByIdData} projectLookups={projectLookups} getallActiveUsers={getallActiveUsers} refetchApiAfterWizard={refetchApiAfterWizard} />} />
                                }
                                {viewFunding &&
                                    <Route path={`/funding/:projectId`} element={<FundingTab projectId={projectId} refetchClientView={refetchClientView} />} />
                                }
                                {viewSpecificationException &&
                                    <Route path={`/specificationException/:projectId`} element={<SpecificationExceptionTab projectLookups={projectLookups} projectId={projectId} />} />
                                }
                                {viewContigencies &&
                                    <Route path={`/contigencies/:projectId`} element={<ContigenciesTab projectId={projectId} />} />
                                }
                                {viewSaleInfo &&
                                    <Route path={`/saleInfo/:projectId`} element={<SalesInfoTab projectId={projectId} getallActiveUsers={getallActiveUsers} projectLookups={projectLookups} refetchClientView={refetchClientView} />} />
                                }
                                {viewFinancial &&
                                    <Route path={`/financial/:projectId`} element={<Financial projectId={projectId} getallActiveUsers={getallActiveUsers} projectLookups={projectLookups} />} />
                                }
                                {viewPrintOuts &&
                                    <Route path={`/printouts/:projectId`} element={<PrintOutTab projectId={projectId} getallActiveUsers={getallActiveUsers} projectLookups={projectLookups} />} />
                                }
                                {viewPermitZonning &&
                                    <Route path={`/permit&Zoning/:projectId`} element={<PermitZoningTab projectId={projectId} getallActiveUsers={getallActiveUsers} projectLookups={projectLookups} />} />
                                }
                                {viewPropertyResource &&
                                    <Route path={`/propertyResource/:projectId`} element={<PropertyResource projectId={projectId} getallActiveUsers={getallActiveUsers} projectLookups={projectLookups} clientViewSummary={clientViewSummary} />} />
                                }
                                {viewPCCPDf &&
                                    <Route path={`/templates/:projectId`} element={<Templates projectId={projectId} getallActiveUsers={getallActiveUsers} projectLookups={projectLookups} />} />
                                }
                                <Route index element={<Navigate to={`/projects/editProject/details/:projectId`} />} />
                            </Route>
                        </Routes>

                        {/* </div>
                        <div className="col-md-3">
                            <UserInfoCard isCollapsed={toggleInfoCard} clientViewSummary={clientViewSummary} handleShowInfoCard={handleShowInfoCard} />
                        </div>
                    </div> */}

                    </div>
                </div>
                <UserInfoCard isCollapsed={toggleInfoCard} clientViewSummary={clientViewSummary} handleShowInfoCard={handleShowInfoCard} projectByIdData={projectByIdData} />

            </div>

        </>
    )
}

export default ProjectsTabsRoutes